// NOTY ACTIONS
export const MARKETPLACE_NOTY_SHOW = 'MARKETPLACE_NOTY_SHOW';
export const MARKETPLACE_NOTY_DISMISS = 'MARKETPLACE_NOTY_DISMISS';
export const MARKETPLACE_NOTY_DIMISS_ALL = 'MARKETPLACE_NOTY_DIMISS_ALL';
